export const NativeMobile = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="25"
    height="25"
    fill="none"
    stroke="black"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <rect x="16" y="8" width="32" height="48" rx="4" />
    <circle cx="32" cy="50" r="2" />
    <rect x="24" y="16" width="16" height="16" rx="2" />
  </svg>
);
